<template>
  <div class="grid bg-white">
    <div class="grid-title">
      <h5 class="text-bold">Production Items Overview</h5>
    </div>
    <div class="grid-body">
      <div id="produciton-items-overview-top-navigation" class="row">
        <div class="col-md-3">
          <input type="text" v-model="params.search" v-on:keyup.enter="getPageData" placeholder="Production Item ID" class="form-control" @keyup.enter="searchByKeyword($event.target.value)" /><br />
        </div>
      </div>
    </div>

    <div id="produciton-items-overview-listings-container" class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
              <th @click="sort('production_items.id')">
                <i class="fa fa-sort"></i> ID
              </th>
              <th @click="sort('product_order_id')">
                <i class="fa fa-sort"></i> Order Number
              </th>
              <th @click="sort('legacy_system_id')">
                <i class="fa fa-sort"></i> Legacy Order number
              </th>
              <th @click="sort('product_type')">
                <i class="fa fa-sort"></i> Product Type
              </th>
              <th @click="sort('status')">
                <i class="fa fa-sort"></i> Status
              </th>
              <th @click="sort('days_in_step')">
                <i class="fa fa-sort"></i> Days in Status
              </th>
              <th @click="sort('age')"><i class="fa fa-sort"></i> Age</th>
              <th class="text-center">Documents</th>
            </tr>
        </thead>
        <tbody>
          <tr v-for="(productionItem,index) in productionItems" :key="index">
            <td>{{ productionItem.id }}</td>
            <td>
              <router-link
                  :to="'/product_order/detail/' + productionItem.product_order_id"
                >
                  {{ productionItem.product_order_id }}
                </router-link>
            </td>
            <td>{{ productionItem.legacy_system_id }}</td>
            <td>{{ productionItem.product_type }}</td>
            <td>{{ productionItem.status }}</td>
            <td>{{ productionItem.days_in_status }}</td>
            <td>{{ productionItem.age }}</td>
            <td class="text-bold text-center">
              <a v-if="productionItem.can_print_production_sheet"
                @click="printProductionSheet(productionItem)"
                :class="{
                  'btn btn-primary btn-sm': !productionItem.is_production_sheet_printed,
                  'btn btn-success btn-sm':
                    productionItem.is_production_sheet_printed,
                }"
              >
                Print Production Sheet
              </a>
              <a v-if="productionItem.product_type !== 'curly'"
                  @click="printPattern(productionItem)"
                  :class="{
                    'btn btn-primary btn-sm': !productionItem.is_pattern_printed,
                    'btn btn-success btn-sm':
                      productionItem.is_pattern_printed,
                  }"
                >
                  Print Pattern
                </a>
            </td>
          </tr>
          <tr v-if="loading">
            <td colspan="6" class="text-center">
              <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              Loading ...
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      productionItems: [],
      params: {
        page: 1,
        perPage: 200,
        sorts: [{ columnName: "production_items.id", type: "asc" }],
        status: 'all',
        keyword: null,
        search: null,
      },
      canScroll: false,
      loading: false,
      totalRows: 0,
    }
  },
  watch: {
    $route: function () {
      this.productionItems = [];
      this.params.page = 1;
      this.params.status = this.$route.params.status;
      this.params.search = this.$route.params.search;
      this.getPageData();
    },
  },
  mounted() {
    this.params.status = this.$route.params.status;
    this.params.search = this.$route.params.search;
    this.getPageData();
    this.scroll();
  },
  methods: {
    async getPageData() {
      if(this.params.search){
        this.productionItems = [];
        this.params.page = 1;
        this.params.status = this.$route.params.status;
      }
      this.canScroll = false;
      this.loading = true;
      let params = { ...this.params };
      let result = await axios.get("production_items/listing", { params });
      let response = result.data.data;
      this.totalRows = response.total;
      this.productionItems = this.productionItems.concat(response.data);
      if (response.data.length < this.params.perPage) {
        this.canScroll = false;
      } else {
        this.canScroll = true;
        this.params.page++;
      }
      this.loading = false;
    },
    resetPage() {
      this.params.page = 1;
      this.productionItems = [];
    },
    searchByKeyword: function(keyword) {
    },
    scroll() {
      let self = this;
      window.onscroll = () => {
        var elem = document.getElementsByClassName("page-content")[0];
        if (self.canScroll == true) {
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            self.getPageData();
          }
        }
      };
    },
    async printProductionSheet(productionItem) {
      productionItem.is_production_sheet_printed = true;
      await ezy.openPDFInNewWindow(`production_items/production_sheet/${productionItem.id}`);
    },
    async printPattern(productionItem) {
      productionItem.is_pattern_printed = true;
      await ezy.openPDFInNewWindow(`production_items/pattern/${productionItem.id}`)
    }
  }
}

</script>

<style scoped>

</style>
